import { useState, useEffect } from 'react'

/**
 * This hook is used to perform validation on the data input
 * by the user at the login form. It retuens a boolean
 * value based on the correctness of the detials
 *
 * @param phone_number
 * @param otp
 */
const useLoginValidation = (phone_number, otp) => {
    const [isOTPValid, setIsOTPValid] = useState(true)
    const [isPhoneValid, setIsPhoneValid] = useState(true)

    useEffect(() => {
        const checkPhone = () => {
            // check regex
            const regex = /^[6789]\d{9}$/

            if (phone_number.length === 10 && regex.test(phone_number)) {
                setIsPhoneValid(true)
            } else {
                setIsPhoneValid(false)
            }
        }

        checkPhone()
    }, [phone_number])

    useEffect(() => {
        const checkOtp = () => {
            if (otp.length === 6) {
                setIsOTPValid(true)
            } else {
                setIsOTPValid(false)
            }
        }

        checkOtp()
    }, [otp])

    return { isOTPValid, isPhoneValid }
}

export default useLoginValidation
